import { useEffect } from "react"
import { toast } from "@kit/design/toast"
import { ReactRB } from "./api"

/**
 * Handles dispatching calls from ReactRB.flash to toast.
 * The reason this is named "flash" is to match Rails naming. The purpose of
 * this feature is to support standard rails flash messages on React pages.
 */
export function useFlash() {
  useEffect(() => {
    const handler = ({ type, data }) => {
      switch (type) {
        case "flash": {
          toast(data)
        }
      }
    }
    ReactRB.subscribe(handler)
    return () => ReactRB.unsubscribe(handler)
  }, [])
}
